import { combineReducers } from '@reduxjs/toolkit';

import commonReducer from './slice';
import authReducer from '../modules/auth/stores/slice';
import hubReducer from '../modules/hubs/stores/slice';
import FleetReducer from '../modules/fleets/stores/slice';
import OrderReducer from '../modules/orders/stores/slice';
import DriverReducer from '../modules/drivers/stores/slice';
import scheduledReducer from '../modules/scheduler-forms/stores/slice';
import routeReducer from '../modules/routes/stores/slice';
import OrderTicketsReducer from '../modules/order-tickets/stores/slice';
import AdminUserReducer from '../modules/admin-users/stores/slice';
import PartnerReducer from '../modules/partners/stores/slice';
import PartnerOrderReducer from '../modules/partner-orders/stores/slice';

const appReducer = combineReducers({
  common: commonReducer,
  auth: authReducer,
  hub: hubReducer,
  fleet: FleetReducer,
  order: OrderReducer,
  driver: DriverReducer,
  schedulerForm: scheduledReducer,
  route: routeReducer,
  orderTickets: OrderTicketsReducer,
  adminUser: AdminUserReducer,
  partner: PartnerReducer,
  partnerOrder: PartnerOrderReducer,
});

const rootReducer = (state, action) => {
  return appReducer(state, action);
};

export default rootReducer;
